import React, { FC } from "react"
import { Button, Select, Typography } from "antd"
import { ArrowDownOutlined, ArrowUpOutlined } from "@ant-design/icons"

export const OrderedListEditor: FC<{
  value?: string[];
  onChange?: (v: string[]) => void;
  options: string[];
}> = ({ value = [], onChange, options }) => {
  const move = (index: number, direction: -1 | 1) => {
    const next = [...value]
    const target = index + direction

    if (target < 0 || target >= next.length) return
    ;[next[index], next[target]] = [next[target], next[index]]
    onChange?.(next)
  }

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
      {value.map((item, i) => (
        <div
          key={item}
          style={{
            display: "flex",
            alignItems: "center",
            gap: 8,
            background: "#fafafa",
            border: "1px solid #d9d9d9",
            borderRadius: 4,
            padding: "4px 8px",
          }}
        >
          <Typography.Text style={{ flex: 1, fontFamily: "monospace", fontSize: 12 }}>
            {i + 1}. {item}
          </Typography.Text>
          <Button
            size="small"
            icon={<ArrowUpOutlined />}
            disabled={i === 0}
            onClick={() => move(i, -1)}
          />
          <Button
            size="small"
            icon={<ArrowDownOutlined />}
            disabled={i === value.length - 1}
            onClick={() => move(i, 1)}
          />
        </div>
      ))}
      {options.filter(o => !value.includes(o)).length > 0 && (
        <Select
          placeholder="Add section"
          style={{ marginTop: 4 }}
          options={options.filter(o => !value.includes(o)).map(o => ({ value: o, label: o }))}
          onSelect={(v: string | null) => v && onChange?.([...value, v])}
          value={null}
        />
      )}
    </div>
  )
}
